import { formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatTimeAgo = (date: Date) => {
  const now = new Date();
  const diffInYears = now.getFullYear() - date.getFullYear();

  if (diffInYears > 5) {
    return 'давно';
  }

  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: ru,
  });
};
